var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.793C4 15.2171 4.31039 13.6567 4.91345 12.2008C5.5165 10.7449 6.40042 9.42199 7.51472 8.30769C8.62902 7.19338 9.95189 6.30947 11.4078 5.70641C12.8637 5.10336 14.4241 4.79297 16 4.79297C17.5759 4.79297 19.1363 5.10336 20.5922 5.70641C22.0481 6.30947 23.371 7.19338 24.4853 8.30769C25.5996 9.42199 26.4835 10.7449 27.0866 12.2008C27.6896 13.6567 28 16.793 28 16.793C28 19.9756 26.7357 23.0278 24.4853 25.2782C22.2348 27.5287 19.1826 28.793 16 28.793C12.8174 28.793 9.76515 27.5287 7.51472 25.2782C5.26428 23.0278 4 19.9756 4 16.793Z",
    fill: "#F57D41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15.793,
    width: 12,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveButton);
export default __webpack_public_path__ + "static/media/removeButton.bdaadd0e7142ae4237a8e2fd7648baa6.svg";
export { ForwardRef as ReactComponent };